<div class="store-additional-insights-panel-container container" fxLayout="column" fxLayoutGap="30px">
  <h1 class="mat-h1 color-primary text-small-caps no-bottom-margin">{{ 'ADDITIONAL_INSIGHTS' | translate }}</h1>
  <hr/>
  <div fxLayout="row wrap" fxLayoutGap="15px">
    <mtn-store-services-card [services]="services" (click)="trackUserClick('Services & Amentities','services')"
                             [isRestrictedLicenseOverlayEnabled]="!hasStandardLicense"></mtn-store-services-card>
    <mtn-analyst-ratings-card [ratings]="ratings" (click)="trackUserClick('Analyst Ratings Available','ratings')"
                              [isRestrictedLicenseOverlayEnabled]="!hasStandardLicense"></mtn-analyst-ratings-card>
    <mtn-simple-alert title="{{ 'NEED_MORE_INSIGHT' | translate }}" (click)="trackUserClick('Need More Insight? ')" color="blue" text="{{ 'GET_HELP_FROM_ANALYSTS' | translate }}"
                      mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                      [analyticsEventParameters]="{'target': 'store-details-additional-insights-request-more-insight-button'}"
                      (alertClick)="openRequestMoreInsightWizard()"></mtn-simple-alert>
  </div>
</div>
